import { Text } from 'govwell-ui'
import { twMerge } from 'tailwind-merge'

export type TagColor = 'default' | 'red' | 'orange' | 'yellow' | 'green' | 'blue'

type Props = {
  color: TagColor
  children: React.ReactNode
}

const TagColorToClassNameMap: Record<TagColor, string> = {
  default: 'border-neutral-300 bg-neutral-50 text-neutral-950',
  red: 'border-red-900 bg-red-50 text-red-900',
  orange: 'border-orange-900 bg-orange-50 text-orange-900',
  yellow: 'border-yellow-900 bg-yellow-50 text-yellow-900',
  green: 'border-green-900 bg-green-50 text-green-900',
  blue: 'border-blue-900 bg-blue-50 text-blue-900',
}

const Tag = ({ children, color }: Props) => {
  return (
    <Text
      className={twMerge(
        // !mb-0 to override the style on `.ant-typography p`
        '!mb-0 inline-block h-[22px] rounded-sm border px-[7px] text-start text-sm text-nowrap',
        TagColorToClassNameMap[color]
      )}
    >
      {children}
    </Text>
  )
}

export default React.memo(Tag)
